<template>
  <div id="myVideo" class="m-popup vedio-popup" @click.stop.prevent="" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.2);z-index: 9001;">
    <table style="  table-layout: fixed;width: 100%;height: 100%;">
      <tr>
        <td>
          <div class="wrapper" style="width: 722px;  border-radius: 0;position: relative;margin: 0 auto;background: #fff;box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
            <div class="header f-ff0" style="border: none;line-height: 60px;height:60px;padding: 0 24px;border-bottom: 1px solid #e8e8e8;">
              <img style="margin-top: 15px;" src="../../assets/images/logo-new-2.png"/>
              <a href="javascript:void(0);" style="float:right;display: inline-block;width: 18px;height: 18px;background: url('https://image.izhaowo.com/www2/images/x.png');margin-top: 20px;" title="关闭"  @click="closeVideo"></a>
            </div>
            <div class="content f-ff0" style="min-height: 100px;">
              <video width="722" height="455"  controls>
                <source :src="url2" type="video/mp4">
              </video>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  export default{
    name:'yunVideo',
    props:['url'],
    data:function () {
      return{
        url2:this.url
      }
    },
    created:function () {

    },
    methods:{
      closeVideo:function () {
        this.$emit("closeYun");
      }
    },
    mounted:function () {

    }
  }

</script>



// WEBPACK FOOTER //
// openYunVideo.vue?612f2f3c